import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import ChatSocketContextContext from "../contexts/chatSocketContext";
import ChatSocketManager from "../libs/chatSocketManager";
import UserContext from "../contexts/userContext";

type Props = {
	ids: string[];
	ownerId?: string;
	className: string;
	label: string;
	type?: string;
	params?: object;
	chatSocket?: ChatSocketManager;
	userId?: string;
};

function ChatLink({ ids, ownerId, className, label, type = null, params = {}, chatSocket, userId }: Props) {
	let query = {};

	ids = [...ids, ownerId].filter((id) => id !== userId).filter((id) => !!id);

	if (type && params) {
		query["type"] = type;
		if (Object.keys(params).length > 0) {
			query["params"] = JSON.stringify(params);
		}
	}

	let [link, setLink] = useState(null);

	useEffect(() => {
		chatSocket
			.getConversation([userId, ...ids])
			.then((res: any) => {
				if (res.success && res.payload) {
					search.set("to", undefined);
					const link = `/messages/conversation/${res.payload.conversationId}`;
					setLink(link);
				}
			})
			.catch(console.log);
	}, [ids]);

	if (link === null) {
		query["to"] = ids.join(",");
		link = "/messages/new";
	}

	const search = new URLSearchParams(query);
	return (
		<Link to={`${link}?${search.toString()}`} className={className} onClick={(e) => e.stopPropagation()}>
			{label}
		</Link>
	);
}

const ChatLinkWithContext = (props: Props) => (
	<UserContext.Consumer>
		{({ userId }) => {
			return (
				<ChatSocketContextContext.Consumer>
					{(context) => <ChatLink {...props} chatSocket={context} userId={userId} />}
				</ChatSocketContextContext.Consumer>
			);
		}}
	</UserContext.Consumer>
);

export default ChatLinkWithContext;
